var BASWebServices;
(function (BASWebServices) {
    'use strict';
    function messageBox($compile) {
        return {
            templateUrl: "views/partials/elements/messageBox.html",
            scope: "=",
        };
    }
    BASWebServices.messageBox = messageBox;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=messageBox.js.map